// "Otomatik Doldur" modunun ne zaman gecerli oldugunu tek yerden belirler.
//
// Ibrahim (kayit 22, 31:43 ve 31:51, iki kez): "Onay sonrasi TUBITAK'ta da
// otomatik doldur gostermeyelim. Manuel doldur."
//
// KURAL BILESIK: yalnizca ONAY_SONRASI_CIROSU kanali + TUBITAK isi. Onay
// sonrasi ama TUBITAK olmayan bir iste otomatik doldur eskisi gibi
// duruyor; diger kanallarda bu alan zaten hic gorunmuyordu.
//
// Is tipi `showIf(formData, currentUser)` imzasina ulasmadigi icin kural
// FORM_CONFIGS'te degil, firma listesini goren `buildRevenueFormFields`
// icinde uygulaniyor (bkz. utils/revenueFormFields.js).

import { jobTypeName } from './jobType';

export const ONAY_SONRASI = 'ONAY_SONRASI_CIROSU';

/**
 * Turkce harf duyarsiz karsilastirma.
 *
 * Regex'in `i` bayragi yetmiyor: "TÜBİTAK"taki noktali I (U+0130) basit
 * buyuk/kucuk katlamada `i`ye donmuyor, noktasiz `ı` da oyle. NFD ile
 * ayirip birlesen isaretleri atinca Ü→U, İ→I oluyor; `ı` ayrica eslenir.
 */
const sadelestir = (metin) => (metin || '')
  .normalize('NFD')
  .replace(/[̀-ͯ]/g, '')
  .replace(/ı/g, 'i')
  .toLowerCase();

/**
 * Is TUBITAK isi mi.
 *
 * Tur adini `jobTypeName` okuyor — legacy `job_type` metni, `job_type_rel`
 * ve diger yedekler orada toplanmis durumda ("is turu okuma: tek yer").
 * Ad kullanici tarafindan giriliyor: "TUBITAK", "TÜBİTAK Projeleri",
 * "Tubitak 1501" hepsi gecerli.
 */
export const isTubitakJob = (job) => sadelestir(jobTypeName(job)).includes('tubitak');

/**
 * fill_mode'un GECERLI degeri. Onay sonrasi TUBITAK isinde kullanicinin
 * kayitli degeri ne olursa olsun 'manual' — eski girisler 'auto'
 * kaydedilmis olabilir, onlar da artik manuel davranir.
 */
export const resolveFillMode = (formData, job) => {
  if (formData?.ciro_kanali === ONAY_SONRASI && isTubitakJob(job)) return 'manual';
  return formData?.fill_mode ?? 'auto';
};

/** formData.firm_id + job_id uzerinden secili is kaydini bulur. */
export const findSelectedJob = (firms, formData) => {
  const firm = (Array.isArray(firms) ? firms : []).find(
    (fm) => fm.id === parseInt(formData?.firm_id, 10) || fm.id === formData?.firm_id,
  );
  return firm?.jobs?.find((j) => j.id === formData?.job_id) || null;
};
